import once from 'lodash/once';
import { track } from '../../vendor/splitmetrics-track';



export const EVENT_NAME = 'description_open';


export default once(() => {
  track(EVENT_NAME, { label: 'whats_new' }, { once: true });
});



// WEBPACK FOOTER //
// ./src/lib/track-event/whats-new-block-view.js